import { Layout } from "@murm/ant";
import { useAuth } from "../../hooks/useAuth";
import { useLocation } from "react-router-dom";
import { ExplorerAppHeader } from "./ExplorerAppHeader";
import styles from "./AppShell.module.css";

const { Content } = Layout;

/**
 * Explorer shell: cream canvas + serif wordmark header (design lib) when authenticated.
 */
export function AppShell({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  const onLogin = location.pathname === "/login";
  const showHeader = isAuthenticated && !isLoading && !onLogin;

  return (
    <Layout className={styles.layout}>
      {showHeader ? <ExplorerAppHeader /> : null}
      <Content className={showHeader ? `${styles.content} ${styles.withHeader}` : styles.content}>
        {children}
      </Content>
    </Layout>
  );
}
